/* eslint-disable indent */
import { useLocales } from '@/Locales';

import GeneratePPTNotes from '@/components/GeneratePPTNotes';
import usePermission from '@/hooks/usePermission';
import PatientTag from '@/pages/combinedWard/patientCaseTag/components/PatientTag';
import { patientPPTGenerate } from '@/services/patient';
import { userInfoAtom } from '@/store/atom';
import { getToken } from '@/utils/cookies';
import { encrypt } from '@/utils/sm-crypto';
import { Divider, Space } from '@sinohealth/butterfly-ui-components';
import html2canvas from 'html2canvas';
import _ from 'lodash';
import React, { useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { PatientInfoStatus } from '../../detail';
import QualityScore from '../QualityScore';
import styles from './index.less';

interface HeaderProps {
  patientInfo?: any;
  score?: boolean;
}

const Header: React.FC<HeaderProps> = (props) => {
  const { patientInfo, score } = props;
  const [params] = useSearchParams();
  const id = params.getAll('id')[0];
  const doctorId = params.getAll('doctorId')[0];
  // 用于测试生成时间轴图片
  const debugGenera = params.getAll('debug')[0] === '1';
  const formType = params.get('type'); // share 共享病例库
  const { t } = useLocales();
  const permission = usePermission('patientDetail');
  const userInfo = useRecoilValue(userInfoAtom);
  const generatePPTNotesRef = useRef<any>(null);
  const roleCodes = userInfo?.roleCodes || [];
  const employeeId = userInfo?.employee?.id;

  const [patientInfoStatus, setPatientInfoStatus] = useRecoilState(PatientInfoStatus);

  const navigateToTimeline = (type = 'summaryLecture') => {
    const edit = ((doctorId && doctorId === employeeId) || !doctorId) && !isShareType ? '' : 'home';
    const query = `patientId=${encrypt(patientInfo?.patient?.id)}&type=${type}&edit=${edit}`;
    // 讲稿的共享字段，判断脱敏
    const share = !isShareType ? '' : '&share=share';
    window.open(`${window.location.pathname}#/speech-lecture/lecture?${query}${share}`);
  };

  const isShareType = formType === 'share'; // 病例库进来

  const handleMakeSpeech = (type = 'summaryLecture') => {
    navigateToTimeline(type);
  };

  const handleMakeTimelineSpeech = () => {
    const query = `patientId=${encrypt(patientInfo?.patient?.id)}`;
    window.open(`${window.location.pathname}#/combinedWard/timelineLecture?${query}`);
  };

  const handleGeneraCodeImg = _.debounce(() => {
    if (!debugGenera) return;

    const dom: any = document.querySelector('#timelineCanvas');
    html2canvas(dom, {
      scale: 3, // 可以调整缩放比例
      // backgroundColor: '#fff', // 设置背景色为白色
      useCORS: true, // 如果图片或资源来自不同源，需要启用 CORS
      width: dom.scrollWidth,
      height: dom.scrollHeight,
      windowHeight: dom.scrollHeight * 1.5,
      windowWidth: dom.scrollWidth * 1.5,
    }).then((canvas) => {
      const saveUrl: any = canvas.toDataURL('image/jpg');
      const a: any = document.createElement('a');
      document.body.appendChild(a);
      a.href = saveUrl;
      a.download = `${patientInfo?.patient?.name}_病例时间轴.jpg`;
      a.click();
    });
  }, 500);

  const xtoken = getToken();
  // console.log({ xtoken });
  const handleDownloadPPT = () => {
    patientPPTGenerate({
      patientId: patientInfo?.patient?.id,
    });
    // console.log({ xtoken });
    // if (!xtoken) return;
    // const downloadUrl = `${baseURL}${apiPrefix}/patientPPT/generate/v2?patientId=${patientInfo?.patient?.id}&X-Token=${xtoken}`;
    // window.open(downloadUrl, '_blank');
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles['header-container']}>
          <span className={styles.title}> {t('批量上传病例资料')}</span>
          {props?.children}
          <Space split={<Divider type="vertical" />}>
            {/* {patientInfoStatus.edit && (
              <Link
                to={`patientSummary?id=${patientInfo?.patient.id}&patientId=${patientInfo?.patient.id}`}
              >
                <i className="iconfont icon-bianjizhaiyao" /> {t('编辑摘要')}
              </Link>
            )} */}
            {/* {patientInfoStatus.edit && (
              <Link to={`/combinedWard/timelineLecture?patientId=${patientInfo?.patient?.id}`}>
                <i className="iconfont icon-bianjishijianzhou" /> {t('编辑时间轴')}
              </Link>
            )} */}
            {/* <a
              style={{ display: 'flex', alignItems: 'center', gap: 6 }}
              onClick={() => handleMakeSpeech()}
              id="mdt-btn"
            >
              <i className="iconfont icon-yulanzhaiyaoxingjianggao" /> {t('预览MDT讲稿')}
            </a> */}
            {/* <a onClick={() => handleMakeSpeech('timelineLecture')}>
              <i className="iconfont icon-yulanshijianzhouxingjianggao" /> {t('预览时间轴型讲稿')}
            </a> */}
            {/* {permission?.pptDownload && patientInfoStatus.edit && (
              <div>
                <a onClick={() => generatePPTNotesRef.current.open(patientInfo?.patient?.id)}>
                  <i className="iconfont icon-ppt" /> {t('生成PPT')}
                </a>
                <Tooltip title={t('系统可根据已上传的病例内容生成PPT报告')}>
                  <QuestionCircleOutlined
                    style={{ cursor: 'pointer', color: '#A8A8A8', marginLeft: 4 }}
                  />
                </Tooltip>
              </div>
            )} */}
          </Space>
        </div>
      </div>
      {score && !isShareType && (
        <QualityScore style={{ marginBottom: 12, borderBottom: '1px solid #0000001c' }} />
      )}
      <div className={styles.header} style={{ marginBottom: 12, border: 0 }}>
        <div className={styles['header-container']}>
          <span className={styles.title}> {t('病例标签')}</span>
          <div style={{ padding: '12px 0' }}>
            <Space wrap>
              {!isShareType &&
                patientInfo?.zhPatientLabelList?.map((el: any) => (
                  <PatientTag border key={el?.id} color={el?.type === 0 ? 'processing' : 'warning'}>
                    {el?.name}
                  </PatientTag>
                ))}
              {isShareType &&
                patientInfo?.zhPatientLabelList?.map(
                  (el: any) =>
                    el?.type === 0 && (
                      <PatientTag
                        border
                        key={el?.id}
                        color={el?.type === 0 ? 'processing' : 'warning'}
                      >
                        {el?.name}
                      </PatientTag>
                    ),
                )}
              {!patientInfo?.zhPatientLabelList?.length && t('暂无标签')}
              {((doctorId && doctorId === employeeId) ||
                (!doctorId && roleCodes?.includes('doctor'))) &&
                !isShareType && (
                  <Link
                    to={`/patient/detail/patientCaseTag?patientId=${encrypt(
                      id,
                    )}&labelIds=${patientInfo?.zhPatientLabelList
                      ?.map((el: any) => el?.labelId)
                      .join(',')}`}
                  >
                    <i className="iconfont icon-bianjibiaoqian" /> {t('编辑标签')}
                  </Link>
                )}
            </Space>
          </div>
        </div>
      </div>
      {/* {debugGenera && <TimelineCases edit capture />} */}
      <GeneratePPTNotes ref={generatePPTNotesRef} />
    </>
  );
};

export default Header;
